import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { interessesDaFicha, marcarInteresseAtendido, urlApi, avaliacoesDaFicha, responderAvaliacao, equipeDaFicha, decidirEquipe } from "../services/api";

// 🎓 PAINEL DO PARCEIRO — cadastros do modelo novo (22/10/2026): situação de cada ficha (uma por unidade), editar,
// ver a página e os INTERESSADOS recebidos. Só aparecem os pedidos feitos a ESTE parceiro, com o aceite do candidato
// (LGPD): nome, e-mail e telefone, nada do currículo. "Atendido" alimenta o índice de resposta da página.
// 22/10/2026: + avaliações dos alunos (responder em público), EQUIPE da escola (o dono aprova quem pediu acesso) e
// pedido com autorização RETIRADA (aparece sem nenhum dado). Quem é da equipe ("papel" = equipe) não edita a ficha.
const STATUS = {
  rascunho: ["Rascunho", "bg-slate-100 text-slate-700"],
  aguardando: ["⏳ Aguardando aprovação", "bg-amber-100 text-amber-800"],
  aprovado: ["✅ No ar", "bg-green-100 text-green-800"],
};
const data = (iso) => (iso ? new Date(iso).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "");

export function MeusCadastrosParceiro({ fichas }) {
  return (
    <section className="mt-4 space-y-3">
      {fichas.map((f) => <CartaoFicha key={f.id} f={f} />)}
      <Link to="/parceiro/cadastro?nova=1" className="inline-block bg-white border border-gray-300 text-gray-700 font-bold rounded-lg px-4 py-2 text-sm">
        ＋ {fichas.length ? "Cadastrar outra unidade" : "Começar meu cadastro"}
      </Link>
    </section>
  );
}

function CartaoFicha({ f }) {
  const [aberto, setAberto] = useState(false);
  const [lista, setLista] = useState(null);
  const [erro, setErro] = useState("");
  const [st, cls] = STATUS[f.status] || [f.status, "bg-slate-100"];
  const [painel, setPainel] = useState(null);   // "avaliacoes" | "equipe"
  const dono = f.papel !== "equipe";
  const abrir = () => {
    setAberto(!aberto);
    if (!lista) interessesDaFicha(f.id).then(setLista).catch((e) => setErro(e.message));
  };
  const marcar = async (i, v) => {
    try { const r = await marcarInteresseAtendido(f.id, i.id, v); setLista((l) => l.map((x) => (x.id === i.id ? { ...x, atendidoEm: r.atendidoEm } : x))); }
    catch (e) { setErro(e.message); }
  };
  return (
    <div className="bg-white rounded-2xl shadow-sm p-5">
      <div className="flex gap-3 items-start">
        <div className="w-12 h-12 shrink-0 rounded-lg bg-accent text-white font-bold flex items-center justify-center overflow-hidden">
          {f.logoUrl ? <img src={urlApi(f.logoUrl)} alt="" className="w-full h-full object-cover" /> : (f.nome || "?").slice(0, 2).toUpperCase()}
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex flex-wrap items-center gap-2">
            <b className="text-text">{f.nome || "Cadastro sem nome"}</b>
            <span className={`rounded-full px-2 py-0.5 text-xs font-semibold ${cls}`}>{st}</span>
            {f.revisaoPendente && <span className="rounded-full px-2 py-0.5 text-xs font-semibold bg-amber-100 text-amber-800">alterações em revisão</span>}
            {f.status === "aprovado" && !f.ativo && <span className="rounded-full px-2 py-0.5 text-xs font-semibold bg-red-100 text-red-700">página pausada</span>}
            {!dono && <span className="rounded-full px-2 py-0.5 text-xs font-semibold bg-sky-100 text-sky-900">você é da equipe</span>}
            {f.aulaParceiroId && <span className="rounded-full px-2 py-0.5 text-xs font-semibold bg-sky-100 text-sky-900">🎥 agenda na sala do eaiRH</span>}
          </div>
          <div className="text-xs text-gray-500 mt-0.5">{f.tipo === "prof" ? "Professor(a) · aula experimental grátis" : "Escola · bolsa"}{f.enviadoEm ? ` · enviado em ${data(f.enviadoEm)}` : ""}</div>
          {f.motivoRecusa && <p className="mt-2 rounded-lg bg-red-50 border border-red-200 text-red-800 text-xs px-2 py-1.5"><b>Ajuste pedido pelo eaiRH:</b> {f.motivoRecusa}</p>}
          <div className="flex flex-wrap gap-2 mt-3">
            {dono && (
              <Link to={`/parceiro/cadastro?id=${f.id}`} className="bg-accent text-white font-bold rounded-lg px-3 py-1.5 text-sm">
                {f.status === "rascunho" ? "Continuar cadastro" : "Editar ficha"}
              </Link>
            )}
            {f.pagina && <Link to={f.pagina} className="border border-gray-300 rounded-lg px-3 py-1.5 text-sm font-semibold text-gray-700">Ver minha página</Link>}
            {f.status === "aprovado" && (
              <button type="button" onClick={abrir} className="border border-primary text-primary rounded-lg px-3 py-1.5 text-sm font-semibold">
                Interessados ({f.interesses}{f.novos ? ` · ${f.novos} a atender` : ""}) {aberto ? "▴" : "▾"}
              </button>
            )}
            {f.status === "aprovado" && (
              <button type="button" onClick={() => setPainel(painel === "avaliacoes" ? null : "avaliacoes")} className="border border-gray-300 rounded-lg px-3 py-1.5 text-sm font-semibold text-gray-700">
                ⭐ Avaliações {painel === "avaliacoes" ? "▴" : "▾"}
              </button>
            )}
            {dono && f.status === "aprovado" && (
              <button type="button" onClick={() => setPainel(painel === "equipe" ? null : "equipe")} className="border border-gray-300 rounded-lg px-3 py-1.5 text-sm font-semibold text-gray-700">
                👥 Equipe{f.equipePendentes ? ` (${f.equipePendentes} pedido${f.equipePendentes > 1 ? "s" : ""})` : ""} {painel === "equipe" ? "▴" : "▾"}
              </button>
            )}
          </div>
        </div>
      </div>
      {aberto && (
        <div className="mt-4 border-t pt-3 text-sm">
          {erro && <p className="text-red-600">{erro}</p>}
          {!lista && !erro && <p className="text-gray-400">Carregando…</p>}
          {lista && lista.length === 0 && <p className="text-gray-500">Nenhum interessado ainda. Cada pedido chega por e-mail aos contatos marcados em "recebe os interessados" e aparece aqui.</p>}
          {lista && lista.length > 0 && (
            <ul className="divide-y">
              {lista.map((i) => (
                <li key={i.id} className="py-2.5 flex flex-wrap gap-3 items-center">
                  {i.retiradoEm ? (
                    <div className="flex-1 min-w-0 text-gray-500">
                      <i>Pedido de {data(i.criadoEm)}: a pessoa retirou a autorização em {data(i.retiradoEm)}.</i>
                      <div className="text-xs">Os dados foram apagados do eaiRH. Apague também do seu lado e não entre mais em contato.</div>
                    </div>
                  ) : (<>
                  <div className="flex-1 min-w-0">
                    <b>{i.nome}</b> <span className="text-xs text-gray-500">· pediu em {data(i.criadoEm)}</span>
                    <div className="text-xs text-gray-700 break-all"><a href={`mailto:${i.email}`} className="text-primary">{i.email}</a> · {i.telefone}</div>
                  </div>
                  <label className="flex items-center gap-1.5 text-xs">
                    <input type="checkbox" checked={!!i.atendidoEm} onChange={(e) => marcar(i, e.target.checked)} /> Atendido
                  </label>
                  </>)}
                </li>
              ))}
            </ul>
          )}
          <p className="text-[11px] text-gray-400 mt-2">Use estes dados só para o contato sobre o curso, com no máximo 3 tentativas. Se a pessoa pedir para não ser mais contatada, é só atender.</p>
        </div>
      )}
      {painel === "avaliacoes" && <AvaliacoesDoPainel f={f} />}
      {painel === "equipe" && <EquipeDoPainel f={f} />}
    </div>
  );
}

function AvaliacoesDoPainel({ f }) {
  const [d, setD] = useState(null);
  const [erro, setErro] = useState("");
  const [texto, setTexto] = useState({});
  const carregar = () => avaliacoesDaFicha(f.id).then(setD).catch((e) => setErro(e.message));
  useEffect(() => { carregar(); }, [f.id]); // eslint-disable-line react-hooks/exhaustive-deps
  const responder = async (a) => {
    setErro("");
    try {
      await responderAvaliacao(f.id, a.id, texto[a.id] ?? "");
      setTexto((t) => { const n = { ...t }; delete n[a.id]; return n; });
      carregar();
    } catch (e) { setErro(e.message); }
  };
  return (
    <div className="mt-4 border-t pt-3 text-sm">
      {erro && <p className="text-red-600">{erro}</p>}
      {!d && !erro && <p className="text-gray-400">Carregando…</p>}
      {d && d.pendentes > 0 && <p className="text-xs text-gray-500 mb-2">{d.pendentes} avaliação(ões) com comentário em moderação no eaiRH.</p>}
      {d && d.lista.length === 0 && <p className="text-gray-500">Nenhuma avaliação ainda. Uns dias depois de cada pedido, o eaiRH pergunta ao candidato como foi.</p>}
      {d && d.lista.length > 0 && (
        <ul className="divide-y">
          {d.lista.map((a) => {
            const editando = texto[a.id] !== undefined;
            return (
              <li key={a.id} className="py-3">
                <div>
                  <span className="text-amber-500">{"★".repeat(a.nota)}{"☆".repeat(5 - a.nota)}</span> <b>{a.nome}</b>{" "}
                  <span className="text-xs text-gray-500">· {data(a.criadoEm)}{a.contatou === true ? " · recebeu contato" : a.contatou === false ? " · diz que NÃO recebeu contato" : ""}</span>
                </div>
                {a.comentario && <p className="mt-1 text-gray-700 whitespace-pre-line">{a.comentario}</p>}
                {a.comentarioRecusado && <p className="mt-1 text-xs text-gray-400">(comentário não publicado pela moderação; a nota vale)</p>}
                {a.resposta && !editando && (
                  <div className="mt-2 ml-3 border-l-4 border-primary/40 pl-3">
                    <div className="text-xs text-gray-500">Sua resposta pública · {data(a.respostaEm)}</div>
                    <p className="whitespace-pre-line">{a.resposta}</p>
                    <button onClick={() => setTexto((t) => ({ ...t, [a.id]: a.resposta }))} className="text-xs font-semibold text-primary">Corrigir resposta</button>
                  </div>
                )}
                {(!a.resposta || editando) && (
                  <div className="mt-2">
                    <textarea value={texto[a.id] ?? ""} onChange={(e) => setTexto((t) => ({ ...t, [a.id]: e.target.value }))} maxLength={1000} rows={2}
                      className="w-full border border-gray-300 rounded-lg px-2 py-1.5 text-sm" placeholder="Responder em público (aparece na sua página, abaixo da avaliação)" />
                    <button disabled={(texto[a.id] || "").trim().length < 10} onClick={() => responder(a)}
                      className="mt-1 bg-accent text-white font-bold rounded-lg px-3 py-1 text-xs disabled:opacity-40">Publicar resposta</button>
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      )}
      <p className="text-[11px] text-gray-400 mt-2">A resposta é pública e passa pelo mesmo filtro dos relatos (e-mail, telefone e ofensas são escondidos). Quem avaliou recebe um aviso.</p>
    </div>
  );
}

function EquipeDoPainel({ f }) {
  const [l, setL] = useState(null);
  const [erro, setErro] = useState("");
  const carregar = () => equipeDaFicha(f.id).then(setL).catch((e) => setErro(e.message));
  useEffect(() => { carregar(); }, [f.id]); // eslint-disable-line react-hooks/exhaustive-deps
  const decidir = async (m, acao) => {
    setErro("");
    if (acao === "remover" && !window.confirm(`Tirar o acesso de ${m.nome}?`)) return;
    try { await decidirEquipe(f.id, m.id, acao); carregar(); } catch (e) { setErro(e.message); }
  };
  return (
    <div className="mt-4 border-t pt-3 text-sm">
      <p className="text-xs text-gray-500">Outras pessoas da escola podem pedir acesso a este painel: só quem está nos <b>contatos da ficha</b> com e-mail do <b>mesmo domínio</b> da escola (e-mail confirmado). Quem você aprovar vê os interessados, marca &quot;atendido&quot; e responde às avaliações; editar a ficha continua só com você.</p>
      {erro && <p className="text-red-600 mt-2">{erro}</p>}
      {!l && !erro && <p className="text-gray-400 mt-2">Carregando…</p>}
      {l && l.length === 0 && <p className="text-gray-500 mt-2">Ninguém pediu acesso ainda.</p>}
      {l && l.length > 0 && (
        <ul className="divide-y mt-2">
          {l.map((m) => (
            <li key={m.id} className="py-2 flex flex-wrap items-center gap-2">
              <div className="flex-1 min-w-0">
                <b>{m.nome}</b> <span className="text-xs text-gray-500 break-all">· {m.email}</span>
                <div className="text-xs text-gray-500">{m.status === "pendente" ? `pediu em ${data(m.criadoEm)}` : `com acesso desde ${data(m.decididoEm)}`}</div>
              </div>
              {m.status === "pendente" ? (
                <>
                  <button onClick={() => decidir(m, "aprovar")} className="bg-green-600 text-white font-bold rounded-lg px-3 py-1 text-xs">Aprovar</button>
                  <button onClick={() => decidir(m, "recusar")} className="bg-white border border-gray-300 font-bold rounded-lg px-3 py-1 text-xs">Recusar</button>
                </>
              ) : <button onClick={() => decidir(m, "remover")} className="text-xs font-semibold text-red-700">Tirar acesso</button>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

// Contas que estão nos contatos de uma ficha (mesmo domínio da escola) e podem pedir acesso ao painel dela.
export function PedirAcessoEquipe({ acessos, onPedido }) {
  const [erro, setErro] = useState("");
  if (!acessos || acessos.length === 0) return null;
  const pedir = async (a) => {
    setErro("");
    try { await onPedido(a); } catch (e) { setErro(e.message); }
  };
  return (
    <section className="mt-4 rounded-2xl bg-sky-50 border border-sky-200 p-4 text-sm">
      <b className="text-sky-900">👥 Sua escola já está no eaiRH</b>
      <p className="text-sky-900 mt-1">Você está nos contatos destes cadastros com o e-mail da escola. Peça acesso ao painel: quem fez o cadastro aprova.</p>
      {erro && <p className="text-red-600 mt-2">{erro}</p>}
      <ul className="mt-2 space-y-1.5">
        {acessos.map((a) => (
          <li key={a.id} className="flex flex-wrap items-center gap-2">
            <b>{a.nome}</b>
            {a.status === "pendente" ? <span className="text-xs text-amber-800">⏳ pedido enviado, aguardando aprovação</span>
              : a.status === "aprovado" ? <span className="text-xs text-green-800">✅ acesso liberado</span>
                : !a.emailConfirmado ? <span className="text-xs text-gray-600">confirme o seu e-mail para pedir acesso</span>
                  : <button onClick={() => pedir(a)} className="bg-white border border-sky-300 text-sky-900 font-bold rounded-lg px-3 py-1 text-xs">Pedir acesso ao painel</button>}
          </li>
        ))}
      </ul>
    </section>
  );
}
